<template>
  <div class="right-section">
    <div class="pt-5 d-flex flex-column" style="width: 320px">
      <!-- Discover Card -->
      <!-- <v-card class="mb-5 rounded-lg" elevation="2">
        <v-subheader class="font-weight-bold">Discover More</v-subheader>
        <v-img
          src="https://images.unsplash.com/photo-1517486808906-6ca8b3f8e1c1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          aspect-ratio="1.2"
          class="white--text align-end"
          gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
        >
          <v-card-title class="text-h6">Explore Nature</v-card-title>
        </v-img>
        <v-card-text class="px-3 py-2">
          <div class="text-caption grey--text text--darken-1">
            #outdoors #hiking #nature
          </div>
          <v-btn small block outlined color="primary" class="mt-2"  @click="goToProfile">
            <v-icon left>mdi-compass</v-icon>
            Explore
          </v-btn>
        </v-card-text>
      </v-card> -->

      <v-card class="mb-5 rounded-lg" elevation="2">
  <v-subheader class="font-weight-bold">Discover More</v-subheader>
  
  <!-- Video Player -->
  <vue-plyr>
    <video controls crossorigin playsinline>
      <source 
        src="@/assets/UnauthRightCard.mp4" 
        type="video/mp4"
      >
      <!-- Fallback image if video can't load -->
      <v-img
        src="https://images.unsplash.com/photo-1517486808906-6ca8b3f8e1c1?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
        aspect-ratio="1.2"
        class="white--text align-end"
        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
      >
        <v-card-title class="text-h6">Explore Nature</v-card-title>
      </v-img>
    </video>
  </vue-plyr>

  <v-card-text class="px-3 py-2">
    <div class="text-caption grey--text text--darken-1">
      #outdoors #hiking #nature
    </div>
    <v-btn small block outlined color="primary" class="mt-2" @click="goToProfile">
      <v-icon left>mdi-compass</v-icon>
      Explore
    </v-btn>
  </v-card-text>
</v-card>


      <!-- Trending Topics -->
      <v-card class="mb-5 rounded-lg" elevation="1"  @click="goToProfile">
        <v-subheader class="font-weight-bold">Trending Topics</v-subheader>
        <v-list dense>
          <v-list-item v-for="(topic, i) in trendingTopics" :key="i">
            <v-list-item-content>
              <v-list-item-title class="font-weight-medium">#{{ topic }}</v-list-item-title>
              <v-list-item-subtitle class="text-caption">{{ topicCounts[i] }} posts</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon small>
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-card>

      <!-- Quick Links -->
      <v-card class="mb-5 rounded-lg" elevation="1"  @click="goToProfile">
        <v-subheader class="font-weight-bold">Quick Links</v-subheader>
        <v-list dense>
          <v-list-item @click="goToAboutUs">
            <v-list-item-icon>
              <v-icon small>mdi-information</v-icon>
            </v-list-item-icon>
            <v-list-item-title>About Us</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goToPrivacy">
            <v-list-item-icon>
              <v-icon small>mdi-shield-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Privacy Policy</v-list-item-title>
          </v-list-item>
          <v-list-item @click="goToTOS">
            <v-list-item-icon>
              <v-icon small>mdi-file-document</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Terms of Service</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>

      <!-- Footer -->
      <v-card class="rounded-lg" elevation="1" color="white" flat>
        <v-card-text class="text-center px-0">
          <div class="d-flex justify-center">
            <v-btn icon small class="mx-1">
              <v-icon small>mdi-facebook</v-icon>
            </v-btn>
            <v-btn icon small class="mx-1">
              <v-icon small>mdi-twitter</v-icon>
            </v-btn>
            <v-btn icon small class="mx-1">
              <v-icon small>mdi-instagram</v-icon>
            </v-btn>
          </div>
          <div class="text-caption grey--text mt-2">
            © {{ new Date().getFullYear() }} {{appTitle}}
          </div>
          <div class="text-caption grey--text">
            All rights reserved
          </div>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
import VuePlyr from 'vue-plyr'
import 'vue-plyr/dist/vue-plyr.css'
export default {
      components: { VuePlyr },
  data() {
    return {
      trendingTopics: [
        'Volunteering',
        'CommunityHelp',
        'SocialWork',
        'CharityEvents',
        'DonationDrive'
      ],
      topicCounts: [
        '12.5K',
        '8.2K',
        '5.7K',
        '3.9K',
        '2.4K'
      ]
    }
  },
     computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE;
    }
  },
  methods: {
    goToAboutUs() {
      this.$router.push({ name: "aboutus" });
    },
    goToPrivacy() {
      this.$router.push({ name: "privacy" });
    },
    goToTOS() {
      this.$router.push({ name: "terms-of-service" });
    },
    goToProfile() {
      this.$router.push({ name: "login" });
    },
  }
};
</script>

<style scoped>
.right-section {
  max-height: 100vh;
  overflow-y: hidden;
  position: sticky;
  min-height: inherit;
  overflow-x: hidden;
  top: 56px;
  min-width: 350px;
  max-width: 350px;
  padding-left: 20px;
}
.right-section:hover {
  overflow-y: auto;
}
.right-section::-webkit-scrollbar {
  width: 6px;
  transition-duration: 0.5s;
}
.right-section::-webkit-scrollbar-track {
  background: rgba(0,0,0,0.05);
  border-radius: 3px;
}
.right-section::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.2);
  border-radius: 3px;
}
.right-section::-webkit-scrollbar-thumb:hover {
  background: rgba(0,0,0,0.3);
}

.v-list-item {
  cursor: pointer;
  transition: all 0.3s ease;
}
.v-list-item:hover {
  background-color: rgba(0,0,0,0.03);
}
.vue-plyr {
  border-radius: 0 0 8px 8px;
  overflow: hidden;
}

/* Make sure video fills container */
.vue-plyr video {
  width: 100%;
  height: auto;
  aspect-ratio: 1.2;
}
</style>